import React from 'react';
import { ISecondaryButtonProps, SecondaryButton } from '../SecondaryButton/SecondaryButton';
import classes from './style.module.scss';

export const QuickFilterButton = (props: ISecondaryButtonProps) => {
	return <SecondaryButton {...props} className={classes.quickFilterButton} disableHover={props.selected} />;
};
